import { Translate } from '@chipinside/translate'
import React from 'react'

import QuickInfo from '#/components/QuickInfo'

const TypeQuickInfo = ({ value, ...rest }) => {
  if (!value) return <span>-</span>
  return (
    <QuickInfo title={Translate({ messageKey: 'information_plural' })} {...rest}>
      {value}
    </QuickInfo>
  )
}

export default TypeQuickInfo
